import * as yup from "yup";

const parseAmount = (value) => parseFloat(value || "0") || 0;

export const TradingSalesSchema = yup.object().shape({
  reference_number: yup.string().nullable(),
  reference_date: yup.string().nullable(),
  voucher_date: yup.string().required("Date is required"),
  narration: yup.string().nullable(),
  number_series: yup.string().required("Number Series is required"),
  entry_number: yup.string().required("Entry Number is required"),
  party: yup.string().required("Party is required"),
  items: yup.array().of(
    yup.object().shape({
      account: yup.string().required("Items is required"),
      quantity: yup
        .number()
        .required("Quantity is required")
        .test("stock-available", function (value) {
          const { available_quantity, is_maintain_stock, previous_quantity } =
            this.parent;

          const quantity = parseAmount(value);
          const availableQty = parseAmount(available_quantity);

          const prevQty = parseAmount(previous_quantity);
          const effectiveAvailable = Number(availableQty);
          if (!is_maintain_stock) return true;

          if (quantity > effectiveAvailable) {
            return this.createError({
              message: `Only ${effectiveAvailable} units available`,
            });
          }
          return true;
        }),
      rate: yup
        .string()
        .required("Rate is required")
        .test("rate-greater-than-last-purchase", function (value) {
          const { last_purchase_price } = this.parent;
          const rate = parseAmount(value);
          const minRate = parseAmount(last_purchase_price);

          if (!minRate) return true;

          if (rate < minRate) {
            return this.createError({
              message: `Rate cannot be less than minimum purchase price (${minRate})`,
            });
          }

          return true;
        }),
      discount: yup
        .mixed()
        .nullable()
        .transform((value) =>
          value == null || value === "" ? 0 : Number(value)
        )
        .test("discount-not-below-min-rate", function (value) {
          const { amount, quantity, last_purchase_price } = this.parent;

          const discount = Number(value) || 0;
          const qty = parseAmount(quantity);
          const amt = parseAmount(amount);
          const minRate = parseAmount(last_purchase_price);

          if (!qty || !minRate) return true;
          if (discount <= 0) return true;

          const totalAfterDiscount = amt - discount;
          const discountedRate = totalAfterDiscount / qty;

          if (discountedRate < minRate) {
            return this.createError({
              message: `Discounted rate (${discountedRate}) is below minimum purchase price (${minRate})`,
            });
          }

          return true;
        })
        .test(
          "discount-less-than-amount",
          "Discount cannot be greater than amount",
          function (value) {
            const { amount } = this.parent;
            if (amount == null || amount === "") return true;
            return Number(value) <= Number(amount);
          }
        ),
      amount: yup.string().required("Amount is required"),
      available_quantity: yup.mixed().nullable(),
      is_maintain_stock: yup.boolean().nullable(),
      last_purchase_price: yup.mixed().nullable(),
    })
  ),
});
export const ServiceSalesSchema = yup.object().shape({
  reference_number: yup.string().nullable(),
  reference_date: yup.string().nullable(),
  voucher_date: yup.string().required("Date is required"),
  narration: yup.string().nullable(),
  number_series: yup.string().required("Number Series is required"),
  entry_number: yup.string().required("Entry Number is required"),
  party: yup.string().required("Party is required"),
  items: yup.array().of(
    yup.object().shape({
      account: yup.string().required("Items is required"),
      quantity: yup
        .mixed()
        .optional()
        .nullable()
        .transform((value) =>
          value == null || value === "" ? 0 : Number(value)
        ),
      rate: yup
        .mixed()
        .optional()
        .nullable()
        .transform((value) =>
          value == null || value === "" ? 0 : Number(value)
        ),
      discount: yup
        .mixed()
        .nullable()
        .transform((value) =>
          value == null || value === "" ? 0 : Number(value)
        )
        .test(
          "discount-less-than-amount",
          "Discount cannot be greater than amount",
          function (value) {
            const { amount } = this.parent;
            if (amount == null || amount === "") return true;
            return Number(value) <= Number(amount);
          }
        ),
      amount: yup.string().required("Amount is required"),
      available_quantity: yup.mixed().nullable(),
      is_maintain_stock: yup.boolean().nullable(),
      last_purchase_price: yup.mixed().nullable(),
    })
  ),
});
